import React from 'react'
import ResourceCenter, { trackResourceCenter } from 'shared/components/common/ResourceCenter/ResourceCenter'
import { closeResourceCenter } from 'shared/components/common/ResourceCenter/resourceCenterStore'
import AnnouncementHistoryList from './AnnouncementCenter/AnnouncementHistoryList'
import type { Announcement } from './AnnouncementCenter/announcementQueue'
import { useAnnouncements } from './AnnouncementCenter/useAnnouncements'
import { useHistoryAnnouncement } from './AnnouncementCenter/useHistoryAnnouncement'
import OnboardingChecklist, { useOnboardingChecklist } from './OnboardingChecklist/OnboardingChecklist'
import { isChecklistComplete } from './OnboardingChecklist/checklistItems'

/**
 * The contractor app's resource center (#25353): the shared panel plus Live Chat and the
 * announcement history that used to sit in the header (#25346). Behind `resourceCenterNext`.
 *
 * The history reuses `useAnnouncements().history`/`unread`, which already leave out page-view
 * announcements that have not fired (#25610). The modal comes from `useHistoryAnnouncement`, shared
 * with the header button. The onboarding checklist (#25354) sits above it and hides once done.
 */
export default function AppResourceCenter() {
  const { enabled: announcementsEnabled, history, unread, mark } = useAnnouncements()
  const { show, view } = useHistoryAnnouncement(mark)
  const checklistItems = useOnboardingChecklist()

  const openAnnouncement = (announcement: Announcement) => {
    closeResourceCenter()
    show(announcement)
    trackResourceCenter('resource_center_opened', 'announcement')
  }

  return (
    <>
      <ResourceCenter
        chat
        checklist={isChecklistComplete(checklistItems) ? undefined : <OnboardingChecklist items={checklistItems} />}
        badge={announcementsEnabled ? unread : 0}
        announcements={
          announcementsEnabled ? (
            <AnnouncementHistoryList announcements={history} onSelect={openAnnouncement} />
          ) : undefined
        }
      />
      {view}
    </>
  )
}
